// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"54916c91","455":"12055b03","977":"be3574ff"}[chunkId] + ".chunk.js";
};